//Intercepts $http calls and sets the config header with an access token. Also handles refresh token logic....
angular
    .module('app')
    .factory('authInterceptor', ['$log', '$q', '$injector', '$localStorage', '$rootScope', '$timeout',
        function ($log, $q, $injector, $localStorage, $rootScope, $timeout) {

            var authInterceptorServiceFactory = {};
            var buffer = [];
            var newToken = '';
            var refreshing = 0;
            var timeObj = {};

            var _request = function (config) {

                $rootScope.lastAction();
                timeObj = new Date();
                config.headers = config.headers || {};

                var loginService = $injector.get('loginService');

                //if the request is to an api end point, add the token to the header
                if (config.url.toLowerCase().indexOf('synergis.webapi') > 0) {

                    if (loginService.access_token != "") {
                        config.headers.Authorization = 'Bearer ' + loginService.access_token;
                    }
                    else {
                        //clear bad token
                        loginService.log('token does not exist');
                    }
                }

                if (config.url.indexOf('localhost:4040') > -1) {
                    if (config.url.indexOf('token') < 0) {
                        config.headers.Authorization = 'Bearer ' + loginService.acs_token;
                    }
                }

                return config;
            };

            //handles the response errors
            var _responseError = function (rejection) {
                //when a request is unauthorized
                if (rejection.status === 401 && rejection.config.url.toLowerCase().indexOf("synergis.webapi") > -1) {
                    var deferred = $q.defer();
                    //add the request to the queu in order to retry it when the token is refreshed.
                    buffer.push({ config: rejection.config, deferred: deferred });
                    //avoid refresh if a refresh operation is already underway
                    if (refreshing == false) {
                        refreshing = true;
                        var loginService = $injector.get('loginService');


                        //refresh the token
                        loginService.refreshToken().then(function () {
                            //indicates the refresh operation is done
                            refreshing = false;
                            //retry all the failed requests
                            loginService.failedRefresh = false;
                            angular.forEach(buffer, function (item) {
                                loginService.log(new Date(), "Retrying " + item.config.url, "with token: ", loginService.access_token.substring(0, 20));
                                $injector.get('$http')(item.config).then(function (response) {
                                    item.deferred.resolve(response);
                                }, function (rejection) {
                                    item.deferred.reject(rejection);
                                });
                            });
                            //clear the buffer
                            buffer = [];
                        }, function (response) {
                            //if the token refresh fails, reject all the deferred promises
                            refreshing = false;
                            loginService.failedRefresh = true;
                            angular.forEach(buffer, function (item) {
                                item.deferred.reject(response);
                            });
                            //clear the buffer
                            buffer = [];
                            $localStorage.refreshToken = "";
                            $localStorage.token = "";
                            loginService.clearData();
                            if ($rootScope.loginHub.connected) {
                                $rootScope.loginHub.invoke('resetConnection');
                            }
                            loginService.log("redirecting to the login page");
                            var state = $injector.get('$state');

                            //check for oauth
                            loginService.checkOauthEnabled().then(function (answer) {
                                if (answer) {
                                    loginService.redirectToOAuth();
                                }
                                else {
                                    state.go("login");
                                }
                            });


                        });

                    }

                    return deferred.promise;
                }
                else if (rejection.status === 401 && rejection.config.url.toLowerCase().indexOf("localhost:4040") > -1) {
                    var loginService = $injector.get('loginService');
                    loginService.logInACS();
                }
                var errorService = $injector.get('errorService');
                errorService.errors.push(rejection);
                /* If not a 401, do nothing with this error.
                 * This is necessary to make a `responseError`
                 * interceptor a no-op. */
                return $q.reject(rejection);
            };

            var _response = function (response) {

                end(response.config.url);
                return response;
            }

            authInterceptorServiceFactory.response = _response;

            authInterceptorServiceFactory.request = _request;
            authInterceptorServiceFactory.responseError = _responseError;

            function end(desc) {
                var endTime = new Date();
                var timeDiff = endTime - timeObj; //in ms
                // strip the ms
                //timeDiff /= 1000;

                // get seconds 
                var seconds = Math.round(timeDiff);
                var loginService = $injector.get('loginService');

                loginService.log(desc + " : " + seconds + " milliseconds");
            }



            return authInterceptorServiceFactory;
        }]);